import { reduxForm } from "redux-form";
import { branch, compose, withProps } from "recompose";
import { withRouter } from "react-router-dom";
export default compose(
  // form prop is needed for redux-form, but we are giving this prop as
  // formName, so we need to rename it. Previously it was done in the withTableParams, but now
  // it doesn't have it by default.
  withProps(({ formName }) => ({ form: formName })),
  // the formName is passed via withTableParams and is often user overridden
  branch((props) => !props.noForm, reduxForm({})),
  // don't use withRouter if noRouter is passed!
  branch((props) => !props.noRouter, withRouter)
);
